<template>
<div class="rate-module">
    <div class="topbar">
        <div class="topbar-left">
            <p>
                <span>费率模板</span>
                <el-popover
                    placement="top-start"
                    width="400"
                    trigger="hover"
                    content="若您的服务费率有调整，您的下级服务费率不变，需手动更新您的下级费率。">
                    <span class="question" slot="reference">?</span>
                </el-popover>
            </p>
            <p>您可根据你的实际情况，设置不同的费率模板，创建二级机构时可选择设置的模板</p>
        </div>
        <div class="topbar-right">
            <el-button @click="moduleVisible.state=1">新增费率模板</el-button>
        </div>
    </div>
    <div class="content">
        <el-table ref="singleTable" :stripe='true' :data="tableData" style="width: 100%" v-loading="loading">
            <el-table-column type="index"></el-table-column>
            <el-table-column property="name" label="模板名称"></el-table-column>
            <el-table-column property="useNums" label="使用渠道数"></el-table-column>
            <el-table-column property="updateTime" width='200px' label="更新时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size='small' @click='operation(1,scope.row)'>修改模板名称</el-button>
                    <el-button type="text" size='small' @click='toDetails(scope.row.id)'>设置费率</el-button>
                    <el-button type="text" size='small' @click='operation(2,scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            class="page"
            layout="prev, pager, next"
            @current-change="getData()"
            :current-page="currentPage"
            :total="dataTotal">
        </el-pagination>
    </div>
    <!--  新增模板  -->
    <el-dialog :title="moduleVisible.txt" width="700px" @close="changeVisible" :visible="getState">
        <el-form :rules="rateRules" :model="rateModule" label-width="100px" ref='addform' label-position="left">
            <el-form-item label="模板名称" prop="name">
                <el-input v-model.trim="rateModule.name" :maxlength='50' placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item prop="rate">
                <span slot="label">
                    <span>费率比</span>
                    <el-popover
                        placement="top-start"
                        width="400"
                        trigger="hover"
                        content="费率比仅作为新建费率模板时所用，新建模板后显示的二级费率=您的费率*费率比，二级补贴比例=您的补贴比例*费率比。">
                        <span class="question" slot="reference">?</span>
                    </el-popover>
                </span>
                <el-input :disabled="moduleVisible.state===2" v-model="rateModule.rate" placeholder="请输入费率比"></el-input>
            </el-form-item>
            <el-form-item label="" class="block">
                <el-button type="warning" plain @click="changeVisible">取消</el-button>
                <el-button type="warning" @click="addRate('addform')" :loading='addloading' >保存</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <!--  删除模板  -->
    <el-dialog title="提示" class="warning-modal" :before-close="handleClose" width="500px" :visible="moduleUsing">
        <p class="modal-content"><i class="el-icon-warning"></i>当前模板有渠道正在使用，不可删除！</p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="moduleUsing = false">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
    export default {
        name: "rateModule",
        data(){
            return {
                loading:false,
                tableData:[],
                dataTotal:0,
                currentPage:1,
                moduleVisible:{
                    state:0,//1=新增，2=修改
                    txt:'新增模板'
                },
                moduleUsing:false,
                addloading:false,//弹窗确认按钮节流
                rateModule:{//Dialog表单对象
                    name:'',
                    rate:''
                },
                rateRules:{
                    name:[{required:true,message:"请输入模板名称"}],
                    rate:[
                        {required:true,message:"请输入费率比"},
                        { validator(rule, value, callback) {
                            if(isNaN(value) || value<0 || value>1){
                                return callback(new Error(rule.message));
                            }else{
                                return callback();
                            }
                        }, message: "请输入大于0小于1的数字", trigger: 'blur' }
                    ]
                },
                currentRow:Object.create(null)
            }
        },
        created() {
            this.getData()
        },
        methods:{
            handleClose(){
                this.moduleUsing=false
            },
            //获取列表数据
            getData(){
                this.loading = true;
                this.$http({
                    url:'/master/rateTpl/list',
                    type:'post',
                    params:{
                        pageNum:this.currentPage
                    }
                }).then((data)=>{
                    this.loading = false;
                    this.tableData=[].concat(data.data)
                    this.dataTotal=data.total
                }).then((data)=>{
                    this.loading = false;
                })
            },
            changeVisible(){
                this.moduleVisible.state=0
                this.moduleVisible.txt='新增模板'
                for (let item in this.rateModule){
                    this.$set(this.rateModule,item,'')
                }
            },
            /**
             * 新增、修改模板
             */
            addRate(form){
                this.$refs[form].validate((res)=>{
                    if(res){
                        let param=JSON.parse(JSON.stringify(this.rateModule))
                        param.rate=Number(param.rate)
                        console.log(param)
                        if(this.moduleVisible.state!==1){
                            param.id=this.currentRow.id
                        }
                        this.$http({
                            url:'/master/rateTpl/template/update',
                            type:'put',
                            params: param,
                        }).then((data)=> {
                            if(this.moduleVisible.state===1){
                                // ...调用新增接口
                                this.changeVisible()
                                this.$confirm(
                                    '新增模板成功，是否开始编辑模板？', '提示', {
                                        confirmButtonText: '是',
                                        cancelButtonText: '否',
                                        type: 'warning'
                                    })
                                .then(()=> {
                                    this.toDetails(data.data.id)
                                }).catch(()=> {
                                    this.getData()
                                });

                            }else{
                                this.$message.success("修改模板成功")
                                // ...调用修改接口
                                this.changeVisible()
                                this.getData()
                            }
                        });
                    }else{
                        return false
                    }
                })
            },
            /**
             * 费率模板操作
             * @param type 1=修改，2=删除
             * @param row
             */
            operation(type,row){
                this.currentRow=row
                if(type===1){
                    this.moduleVisible=Object.assign({},this.moduleVisible,{
                        state: 2,
                        txt:'修改模板'
                    })
                    this.rateModule=Object.assign({},this.rateModule,{
                        name:row.name,
                        rate:row.rate
                    })
                }else{
                    this.$confirm(
                        '确定删除费率模板？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                    .then(()=> {
                        this.$http({
                            url:'/master/rateTpl',
                            type:'delete',
                            params:{
                                ids:row.id
                            }
                        }).then((data)=>{
                            this.$message({
                                message:'删除成功'
                            })
                            this.getData()
                        }).catch((err)=>{
                            if(err.data.data==='当前模板有渠道正在使用，不可删除！'){
                                this.moduleUsing=true
                            }
                        })
                    });
                    // ...调用删除接口

                }
            },
            toDetails(id){
                this.$router.push({
                    path:'/rateDetails',
                    query:{
                        mechanId:id
                    }
                })
            }
        },
        computed:{
            getState:function () {
                return this.moduleVisible.state>0
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/sass/mechanism_m/rateModule";
</style>
